export default __webpack_public_path__ + "assets/hand-plant-default.png";